import React from 'react';

interface ProgressBarProps {
  currentSection: number;
  totalSections: number;
  completionPercentage: number;
  onSectionClick?: (section: number) => void;
}

const sections = [
  { number: 1, name: 'Seller Info' },
  { number: 2, name: 'Communication' },
  { number: 3, name: 'Selling Plans' },
  { number: 4, name: 'Showing Info' },
  { number: 5, name: 'Property Basics' },
  { number: 6, name: 'Interior & Utilities' },
  { number: 7, name: 'Home Features' },
  { number: 8, name: 'HOA Info' },
  { number: 9, name: 'Renovations' },
];

export default function ProgressBar({ 
  currentSection, 
  totalSections, 
  completionPercentage,
  onSectionClick 
}: ProgressBarProps) {
  return (
    <div className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
      <div className="max-w-4xl mx-auto px-4 py-4">
        {/* Overall progress */}
        <div className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">
              Step {currentSection} of {totalSections}
            </span>
            <span className="text-sm font-medium text-gray-700">
              {completionPercentage}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-brand-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
        </div>

        {/* Section navigation */}
        <div className="flex flex-wrap gap-2 justify-center">
          {sections.map((section) => (
            <button
              key={section.number}
              onClick={() => onSectionClick?.(section.number)}
              className={`
                px-3 py-2 rounded-lg text-sm font-medium transition-colors
                ${section.number === currentSection
                  ? 'bg-brand-primary text-white'
                  : section.number < currentSection
                  ? 'bg-green-100 text-green-800 hover:bg-green-200'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }
              `}
              disabled={!onSectionClick}
            >
              <span className="block text-xs mb-1">{section.number}</span>
              <span className="block">{section.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
